<template>
  <div class="popup-form">
    <div class="content-form-popup">
      
      <div class="header-text">
        <modal-close-button aria-label="Zavrieť príjem" :disabled="busy" @click="closePopup" />
        <div class="blackcolor pop-800">
          {{ typeLabel }}
        </div>
        <button form="income-submit" class="w-button saveformBtn" :disabled="busy">{{ busy ? "Prepočítavam…" : "Uložiť" }}</button>
      </div>

      <div v-if="busy" class="income-save-status" role="status" aria-live="polite">
        <v-progress-circular indeterminate :size="22" :width="2" />
        <div><strong>Ukladám príjem a prepočítavam hypotéku</strong><br />Aktualizujem mesačný príjem, limity a ponuky bánk. Môže to chvíľu trvať.</div>
      </div>
      <p v-if="saveError" class="clientError" role="alert">{{ saveError }}</p>
      <fieldset :disabled="busy" :aria-busy="String(busy)" class="income-fields">
      <component
        @income-saved="saveIncome($event)"
        @income-preparing="preparing = $event"
        @income-save-error="saveError = $event"
        :is="activeComponent"
        :income="payload"
        :form-template="form"
        :meta-data="metaData"
        :client-info="clientInfo">
      </component>
      </fieldset>
    </div>
  </div>
</template>

<script>
import zivnost from "./TradesmanForm";
import sro from "./SROForm";
import prenajom from "./RentalIncome";
import zamestnanie from "./EmploymentForm";
import dochodok from "./RetirementPension";
import rodicovskyprispevok from "./MaternityContribution";
import translateFromDBValue from "../../../../../mixins/translateFromDBValue";
import ModalCloseButton from "@/components/shared/ModalCloseButton.vue";

export default {
  name: "ClientIncomePopUp",
  components: {ModalCloseButton, zivnost, sro, zamestnanie, prenajom, dochodok, rodicovskyprispevok},
  props: {
    type: [String, null],
    payload: [Object, null],
    metaData: [Object, null],
  },
  mixins: [
    translateFromDBValue,
  ],
  data: () => ({
    saving: false,
    preparing: false,
    saveError: "",
    incomeOpened: {},
    typeLabel: null,
    activeComponent: null,
    form: null,
    clientInfo: null,
  }),
  computed: {
    busy() { return this.saving || this.preparing; },
  },
  async created () {
    this.clientInfo = this.$store.getters["popupManagerState/getClientInfo"];
    this.typeLabel = this.translateIncomeType(this.type)
    this.activeComponent = this.typeLabel.replace(/\s/g, '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const incomeForm = this.$store.getters["formStore/getFormByType"]("incomeForm");
    const professions = this.$store.getters["formStore/getFormByType"]("professionForm");
    professions.forEach((p) => {
      p.display_name = p.label
      p.value = p.id
    })
    incomeForm.profesia["choices"] = professions;
    this.form = incomeForm;
  },
  methods: {
    closePopup () {
      if (this.busy) return;
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    async saveIncome (incomeSaved) {
      if (this.saving) return;
      this.saving = true;
      this.saveError = '';
      try {
        if (this.payload) {
          const data = {
            id: incomeSaved.incomeInfo.id,
            clientLabel: this.clientInfo.type,
            clientRole: this.clientInfo.type_code,
            object: {
              clientInfo: this.clientInfo,
              ...incomeSaved.incomeInfo,
            },
            employer: incomeSaved.employer,
          };
          await this.$store.dispatch("mortgageDetailState/patchClientIncome", data);
        } else {
          const data = {
            clientLabel: this.clientInfo.type,
            clientRole: this.clientInfo.type_code,
            monthlyIncomes: incomeSaved.monthlyIncomes,
            employer: incomeSaved.employer,
            object: {
              clientInfo: this.clientInfo,
              ...incomeSaved.incomeInfo,
              client: this.clientInfo.id,
            },
          };
          await this.$store.dispatch("mortgageDetailState/createClientIncome", data);
        }
        this.saving = false;
        this.closePopup();
      } catch (error) {
        this.saveError = 'Príjem sa nepodarilo uložiť. Údaje zostali vo formulári, skúste to znova.';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">

.income-fields { border: 0; padding: 0; margin: 0; min-width: 0; }
.income-save-status { display: flex; align-items: center; gap: 12px; padding: 16px; margin: 16px 0; border-radius: 12px; background: var(--app-surface-muted, #172538); color: var(--app-text, inherit); font-size: 13px; line-height: 1.6; }

.popup {
  width: 34%;
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}
</style>
